import ChartPanel from './ChartPanel';
import './Chart.css';

interface ChartProps {
  questionNumber: number;
  questionText: string;
  answers: string[];
  count: Record<string, number>;
  totalRespondents: number;
  showCount?: boolean;
  variant?: 'slideshow' | 'web' | 'print';
}

function Chart({ questionNumber, questionText, answers, count, totalRespondents, showCount = true, variant = 'slideshow' }: ChartProps) {
  const variantClass = variant ? `chart--${variant}` : '';

  return (
    <div className={`chart ${variantClass}`.trim()}>
      <ChartPanel
        questionNumber={questionNumber}
        questionText={questionText}
        answers={answers}
        count={count}
        totalRespondents={totalRespondents}
        showCount={showCount}
      />
    </div>
  );
}

export default Chart;